module.exports = __webpack_public_path__ + "media/img/frontend_application/fast-enquiry-bg-e933c63cc5ac39527177874203bd9445.jpg";